<div class="dialog settings">
  <h2 mat-dialog-title class="header">
    <span class="title">{{ 'location_settings.title' | translate}}</span>
    <button class="close-ref" mat-icon-button mat-dialog-close [title]="'general.close' | translate | titlecase">
      <mat-icon>clear</mat-icon>
    </button>
  </h2>
  <div mat-dialog-content>
    <div class="title">
      <span>{{'location_settings.introduction' | translate }}</span>
    </div>
    <div class="checkbox-area">
      <mat-checkbox #useMyLocation (change)="myLocationChanged($event)">{{ 'location_settings.use_my_location' | translate }}</mat-checkbox>
      <mat-checkbox #useCustomLocation [(ngModel)]="showLocationSelector" (change)="customLocationChanged($event)">{{ 'location_settings.use_custom_location' | translate }}</mat-checkbox>
    </div>
    @if (showLocationSelector) {
      <div class="location-picker">
        <location-search-field [data]="location ? location.split(';')[2] : ''" (locationChanged)="onCustomLocationChanged($event)"></location-search-field>
      </div>
    }
    @if (locationError) {
      <div class="location-error">
        {{'location_settings.no_permissions' | translate}}
      </div>
    }
    @if (location || (useMyLocation.checked && !useCustomLocation.checked)) {
      <div class="location-radius">
        <div class="title">
          {{'location_settings.radius_intro' | translate}}
        </div>
        <div class="slider">
          <span>1 km</span>
          <mat-slider min="1" max="20" thumbLabel tickInterval="1">
            <input matSliderThumb [(ngModel)]="locationRadius"/>
          </mat-slider>
          <span>20 km</span>
        </div>
      </div>
    }
  </div>
  <div mat-dialog-actions class="dialog-buttons">
    <button class="close-ref" mat-flat-button mat-dialog-close [title]="'general.cancel' | translate">
      {{ 'general.cancel' | translate }}
    </button>
    <button class="close-ref" mat-flat-button [title]="'event_steps.step_publish.button_publish' | translate" [disabled]="!location || (!useMyLocation.checked && !useCustomLocation.checked)"
      [color]="!!location ? 'accent' : 'primary'" (click)="save()">
      {{ 'event_steps.step_publish.button_publish' | translate }}
    </button>
  </div>
</div>
